import { render } from "./MemberBenefitContent.vue?vue&type=template&id=5978fd0d&scoped=true"
import script from "./MemberBenefitContent.vue?vue&type=script&lang=js"
export * from "./MemberBenefitContent.vue?vue&type=script&lang=js"

import "./MemberBenefitContent.vue?vue&type=style&index=0&id=5978fd0d&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5978fd0d"]])

export default __exports__